import Breadcrumb from "components/Common/Breadcrumb"
import React from "react"
import { Container } from "reactstrap"
import TdsYearsTable from "./tdsYearsTable"

const TdsYearList = ({ type }) => {
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title={type === "tds" ? "TDS Certificates" : "Account Statements"}
        />
        <TdsYearsTable type={type} />
      </Container>
    </div>
  )
}

export default TdsYearList
